<template>
  <div class="BDraft">
    <div class="allBlogContent">
      <v-article
        :articleList="articleList"
        :articleCount="articleCount"
        :currentPage="currentPage"
        :pageNum="pageNum"
        :isLoading="isLoading"
        :toEdit="true"
        :isDraft="true"
        @showMessage="showMessage"
      ></v-article>
    </div>
  </div>
</template>

<script>
import Article from "@/components/common/article/article";
import { queryDrafteList } from "@/bmob";
export default {
  components: {
    "v-article": Article
  },
  data() {
    return {
      articleList: [],
      articleCount: 0, //文章实际总数
      currentPage: 1, //当前页
      pageNum: 20, //每页总数
      isLoading: true,
      scrollEl: ""
    };
  },
  mounted() {
    this.getDrafteList();
    this.scrollEl = document.getElementById("BAMCom");
    //添加鼠标滚动事件
    this.scrollEl.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    //删除鼠标滚动事件
    this.scrollEl.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    getUserId() {
      return (
        window.localStorage.getItem("userId") ||
        this.$route.query.userId ||
        undefined
      );
    },
    getDrafteList(pageData = { currentPage: 1, pageNum: 20 }) {
      const userId = this.getUserId();
      queryDrafteList({ userId, pageData })
        .then(res => {
          this.articleList.push(...res.articleList); //获取到的文章列表片段信息（不是全部，分段加载）
          this.articleCount = res.count; //实际文章总数
          this.currentPage = pageData.currentPage;
          this.pageNum = pageData.pageNum;
          this.isLoading = false;
          //自动分段加载所有文章(默认开启，关闭后变成下拉懒加载)
          // this.autoLoadArticle();
        })
        .catch(err => {
          this.showMessage(err);
          this.isLoading = false;
        });
    },
    //自动分段加载所有文章
    autoLoadArticle() {
      let allPageNum = Math.ceil(this.articleCount / this.pageNum);
      if (this.currentPage < allPageNum) {
        //当前页小于总页数，才允许加载文章列表数据
        // 页码，分页用，默认第一页
        this.currentPage++;
        // 请求列表数据
        this.getDrafteList({
          currentPage: this.currentPage,
          pageNum: this.pageNum
        });
      }
    },
    // 获取滚动条当前的位置
    getScrollTop() {
      return this.scrollEl.scrollTop;
    },
    // 获取当前可视范围的高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },
    // 获取文档完整的高度
    getScrollHeight() {
      return this.scrollEl.scrollHeight;
    },
    // 滚动事件触发下拉加载
    onScroll() {
      //满足滚动条底部触发获取文章列表
      if (
        this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <=
        0
      ) {
        let allPageNum = Math.ceil(this.articleCount / this.pageNum);
        //判断文章列表加载状态用来防止重复触发请求
        if (!this.isLoading && this.currentPage < allPageNum) {
          //不是加载状态且当前页小于总页数，才允许加载文章列表数据
          // 页码，分页用，默认第一页
          this.currentPage++;
          // 请求列表数据
          this.getDrafteList({
            currentPage: this.currentPage,
            pageNum: this.pageNum
          });
        }
      }
    },
    showMessage(msg) {
      this.$emit("showMessage", msg);
    }
  }
};
</script>

<style lang="less" scoped>
.BDraft {
  padding-top: 30px;
  padding-left: 200px;
  .article {
    margin: auto;
    width: 70%;
  }
}
@media (max-width: 1024px) {
  .BDraft {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 50px;
    padding: 0;
    width: 100%;
    padding-top: unset;
    padding-left: unset;
    .allBlogContent {
      .article {
        width: 100%;
        .info {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// draft.vue?478b736b